import React from 'react';
import {
  FDAccordion, FDAccordionDetails, FDAccordionTitle, FDBox, FDClickableText, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import ExpenseSummaryGroup
  from 'Views/Onboarding/Pages/Survey/SurveyStep/StepLibrary/OnboardingExpenseSummary/ExpenseSummaryGroup';

function ExpenseSummaryGroupsItemized({ groupResources }) {
  const [showDetails, setShowDetails] = React.useState(false);

  return (
    <FDAccordion expanded={showDetails} onChange={() => setShowDetails(!showDetails)}>
      <FDAccordionTitle>
        <FDStack direction={'row'} justifyContent={'center'} width={'100%'}>
          <FDBox width={'40px'} /> {/* This is used to offset the width of the down chevron in order to center the text in the accordion */}
          <FDClickableText
            appearance={'standalone'}
            label={showDetails ? 'Hide expense details' : 'Show expense details'}
          />
        </FDStack>
      </FDAccordionTitle>
      <FDAccordionDetails>
        <FDStack
          direction={'column'}
          spacing={2}
          alignItems={'center'}
          width={'100%'}
        >
          {groupResources.map((group) => {
            return (
              <ExpenseSummaryGroup groupResource={group} key={group.id()} />
            );
          })}
        </FDStack>
      </FDAccordionDetails>
    </FDAccordion>
  );
}

ExpenseSummaryGroupsItemized.propTypes = {
  groupResources: PropTypes.arrayOf(fr.Resource).isRequired,
};

ExpenseSummaryGroupsItemized.defaultProps = {
};

export default ExpenseSummaryGroupsItemized;
